import { Component as BaseComponent, h } from 'preact';
import { bind } from '../util';

class Component extends BaseComponent {
    constructor() {
        super();
        bind(this, ['renderPsychic']);
        this.setState({
            limit: /^m[.-]/.test(window.location.hostname) ? 1 : 2,
            psychics: [],
        });
    }

    componentWillMount() {
        // TODO: move to a saga
        // can't use their api directly, because they don't support CORS
        Promise.resolve($.get('/api/psychics')).then((response) => {
            const psychics = response && response.querySelectorAll && response.querySelectorAll('psychic');
            return psychics && psychics.length ? psychics : [];
        }).then((psychics) =>
            Array.prototype.slice.call(psychics, 0, this.state.limit)
            // psychics is now an array
        ).then((psychics) =>
            psychics.map((psychic) =>
                [
                    'likes',
                    'link',
                    'performerid',
                    'thumb',
                ].reduce((obj, key)  => {
                    obj[key] = psychic.querySelector(key).textContent;
                    return obj;
                }, {})
            )
        ).then((psychics) =>
            this.setState({psychics: psychics})
        );
    }

    render(_, { psychics }) {
        if (!psychics || !psychics.length) {
            return <oranum-psychics />;
        }
        return (
            <oranum-psychics>
                <div class='row'>
                    <div class='small-12 columns'>
                        <h1 class='text-header-2'>
                            Online Spiritual Advisors
                            <span class='text-header-6'>Chat now for up to 10 minutes free!</span>
                        </h1>
                    </div>
                </div>
                <div class='row'>
                    {psychics.map(this.renderPsychic)}
                </div>
            </oranum-psychics>
        );
    }

    renderPsychic(psychic) {
        const last = psychic.likes.lastIndexOf(' ');
        const truncated_likes = psychic.likes.substring(0, last);
        const likes = psychic.likes != truncated_likes ? truncated_likes + '…' : psychic.likes;
        return (
            <div class='small-12 medium-6 columns'>
                <a href={psychic.link} target='_blank'>
                    <img src={psychic.thumb} alt={psychic.performerid} />
                    <h3>{psychic.performerid}</h3>
                </a>
                <p>{ likes }</p>
                <a class='arrow' href={psychic.link} target='_blank'>ENTER MY FREE CHAT ROOM</a>
            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./app/components/oranum-psychics.js